import { setComponentMapOverrides } from '@jutro/uiconfig';

import FNOLBOPWizard from './FNOLBOPWizard';
import FNOLBOWhatPage from './pages/What/WhatPage';
import FNOLBOBuildingPage from './pages/FABuilding/BuildingPage';
import FNOLBODetailsPage from './pages/Details/DetailsPage';

setComponentMapOverrides(
    {
        FNOLBOPWizard: { component: 'FNOLBOPWizard' },
        FNOLBOWhatPage: { component: 'FNOLBOWhatPage' },
        FNOLBOBuildingPage: { component: 'FNOLBOBuildingPage' },
        FNOLBODetailsPage: { component: 'FNOLBODetailsPage' }
    },
    {
        FNOLBOPWizard,
        FNOLBOWhatPage,
        FNOLBOBuildingPage,
        FNOLBODetailsPage
    }
);

export {
    FNOLBOPWizard as default
};
